import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Alert,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Chip,
} from "@mui/material";
import { Check as CheckIcon, Close as CloseIcon } from "@mui/icons-material";
import { Helmet } from "react-helmet-async";
import NewImagesSlider from "../AdDetails/NewImagesSlider";
import LoadingAnimation from "../Animations/LoadingAnimation";

const MyOffers = () => {
  const { id } = useParams();
  console.log(id);
  const [ad, setAd] = useState(null);
  const [offers, setOffers] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));

  const fetchOffers = async () => {
    console.log("fetchOffers Called");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/offers/ad/${id}`
      );
      if (!response.ok) throw new Error("Failed to fetch offers");

      const data = await response.json();
      setOffers(data);
    } catch (error) {
      setError(error.message);
    }
  };

  const fetchAdDetails = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/ads/${id}`
      );
      if (!response.ok) throw new Error("Failed to fetch ad details");

      const data = await response.json();
      setAd(data);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    fetchAdDetails();
    fetchOffers();
  }, [id]);

  console.log(ad);
  console.log(offers);

  const handleResponse = (response, successMessage) => {
    if (response.ok) {
      setSuccess(successMessage);
      setError(null);
      fetchOffers();
    } else {
      setSuccess(null);
      response.json().then((data) => setError(data.message || "Action failed"));
    }
  };

  const handleOfferStatusUpdate = async (offerId, status) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/offers/${offerId}/${status}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      handleResponse(response, `Offer ${status}ed successfully!`);
      setOffers((prevOffers) =>
        prevOffers.map((offer) =>
          offer._id === offerId ? { ...offer, status } : offer
        )
      );
    } catch (error) {
      setError(`Failed to ${status} offer. Please try again.`);
    }
  };

  return (
    <Box sx={{ padding: 5, mb: 5 }}>
      <Typography
        variant="h5"
        sx={{ fontFamily: "ClashGrotesk-Medium", letterSpacing: 1 }}
      >
        Offers Received
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}

      {ad ? (
        <Grid container spacing={4}>
          <Helmet>
            <title>Offers for {ad.title} - Listed.ky</title>
            <meta
              name="description"
              content={`Offers for ${ad.title} - Listed.ky`}
            />
          </Helmet>
          <Grid item xs={12} md={6}>
            <NewImagesSlider adDetails={ad} />
            <Paper
              sx={{
                mt: 2,
                padding: 2,
                border: "1px solid #ddd", // Light border by default
                boxShadow: "none", // No shadow
              }}
            >
              <Chip
                label={`$ ${ad.price.toLocaleString()}`}
                style={{
                  fontFamily: "ClashGrotesk-Medium",
                  letterSpacing: 1,
                  backgroundColor: "var(--primary-color)",
                  color: "white",
                  fontSize: "1 rem",
                  borderRadius: "0",
                }}
              />
              <Typography
                variant="h5"
                sx={{ fontFamily: "ClashGrotesk-Medium", letterSpacing: 1 }}
              >
                {ad.title}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box mt={4}>
              <Typography
                variant="h5"
                sx={{ fontFamily: "ClashGrotesk-Medium", letterSpacing: 1 }}
              >
                Offers for this Ad ({offers.length})
              </Typography>
              {offers.length === 0 ? (
                <Typography
                  sx={{ fontFamily: "ClashGrotesk-Regular", letterSpacing: 1 }}
                >
                  No offers yet.
                </Typography>
              ) : (
                <List>
                  {offers.map((offer) => (
                    <ListItem key={offer._id}>
                      <ListItemText
                        primary={
                          <Typography
                            sx={{
                              fontFamily: "ClashGrotesk-Regular",
                              letterSpacing: 1,
                            }}
                          >
                            <strong>Amount: </strong>${offer.offerAmount}
                          </Typography>
                        }
                        secondary={
                          <>
                            <Typography
                              variant="body2"
                              sx={{
                                fontFamily: "ClashGrotesk-Regular",
                                letterSpacing: 1,
                              }}
                            >
                              <strong>Message: </strong>
                              {offer.offerMessage || "No message"}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontFamily: "ClashGrotesk-Regular",
                                letterSpacing: 1,
                                color:
                                  offer.status === "accepted"
                                    ? "green"
                                    : offer.status === "rejected"
                                    ? "red"
                                    : "gray",
                              }}
                            >
                              <strong>Status: </strong>
                              {offer.status.charAt(0).toUpperCase() +
                                offer.status.slice(1)}
                            </Typography>
                          </>
                        }
                      />
                      <ListItemSecondaryAction>
                        {user?.email === ad.email &&
                          offer.status === "pending" && (
                            <>
                              <IconButton
                                edge="end"
                                color="success"
                                onClick={() =>
                                  handleOfferStatusUpdate(offer._id, "accept")
                                }
                              >
                                <CheckIcon />
                              </IconButton>
                              <IconButton
                                edge="end"
                                color="error"
                                onClick={() =>
                                  handleOfferStatusUpdate(offer._id, "reject")
                                }
                              >
                                <CloseIcon />
                              </IconButton>
                            </>
                          )}
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <LoadingAnimation />
      )}
    </Box>
  );
};

export default MyOffers;
